import React, { Component } from 'react';
import OriginTimepicker from 'bee-timepicker';
import moment from 'moment';
// import 'moment/locale/zh-cn';
// import 'moment/locale/zh-tw';
// import 'moment/locale/en-au';
import { locale, localeLang, config, PubSub, getSysFieldid, getDatetimeFormat, isArrowKeyDown } from '@platform/api';

// if (localeLang === 'simpchn') {
//     moment.locale('zh-cn');
// } else if (localeLang === 'english') {
//     moment.locale('en');
// } else if (localeLang === 'tradchn') {
//     moment.locale('zh-tw');
// } else {
//     moment.locale(`${localeLang}`);
// }
require('bee-timepicker/build/Timepicker.css');
require('./index.less');

const isFunction = function (obj) {
    return typeof obj === 'function';
};

export default class Timepicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localeLang: 'simpchn',
            open: this.props.open || false,
            hasCloseBtn: false,
            value: this.props.value,
        };
    }

    componentWillMount() {
        let { defaultValue, value } = this.props;

        if (defaultValue || value) {
            this.setState({ hasCloseBtn: true });
        }
        this.setState({ localeLang });
        window.addEventListener('mousedown', this.close);
    }

    componentWillReceiveProps(nextProps) {
        if ('datepickerOpen' in nextProps) {
            this.setState({ open: nextProps.open });
        }
        if (nextProps.value && !this.state.hasCloseBtn) {
            this.setState({ hasCloseBtn: true });
        }
        this.setState({ value: nextProps.value });
    }

    componentWillUnmount() {
        // 移除document事件
        window.removeEventListener('mousedown', this.close);
        this.clearOpenPanelToken && PubSub.unsubscribe(this.clearOpenPanelToken);
    }

    //添加x按钮，清空输入框的日期
    clearValue = () => {
        const { formClear, onOpenChange, onClose } = this.props;
        let beforeEventResult = this.props.onClick && this.props.onClick({}, {}, true);
        if (beforeEventResult && typeof beforeEventResult.then === 'function') {
            beforeEventResult.then(res => {
                if (res) {
                    let { disabled } = this.props;
                    this.setState({
                        hasCloseBtn: false,
                        value: '',
                    });
                    if (disabled !== true) {
                        //编辑态的时候点击才清空显示的日期
                        this.onChange(null);
                        // fix NCC-93171
                        onClose?.('');
                        formClear && onOpenChange && onOpenChange(false);
                    }
                }
            });
        } else {
            let { disabled } = this.props;
            this.setState({
                hasCloseBtn: false,
                value: '',
            });
            if (disabled !== true) {
                //编辑态的时候点击才清空显示的日期
                this.onChange(null);
                // fix NCC-93171
                onClose?.('');
            }
        }
    };

    // 用于表格
    close = e => {
        const { onBlur } = this.props;
        const { value } = this.state;
        // 当在面板里的时候做下判断 -- by bbqin
        this.picerPanel = document.querySelector('.u-time-picker-panel') || this.picerPanel;
        // console.log(this.picerPanel, e.target);
        if (
            this.focused && this.timeInputWrap &&
            !this.timeInputWrap.contains(e.target) &&
            !(this.picerPanel && this.picerPanel.contains(e.target))
        ) {
            isFunction(onBlur) && onBlur(value);
            this.focused = false;
            this.keyboarded = false;
        }
    };

    onOpen = (...rest) => {
        this.props.onClick && this.props.onClick(...rest);
        this.setState({
            open:
                this.props.open == undefined ? true : this.state.open,
        });
        this.clearOpenPanelToken = PubSub.subscribe('clearOpenPanel', (msg, { data }) => {
            if (this.timeInputWrap) {
                let elem = this.timeInputWrap.querySelector('input'); // 获取到底层的input
                // console.log('clearOpenPanel subscribe ');
                elem && elem.click();
            }
        });
    };

    // 用于普通表单 失去焦点事件
    onClose = open => {
        let { onOpenChange, onClose, onChange, format } = this.props;
        let { value } = this.state;
        isFunction(onOpenChange) && onOpenChange(false);
        isFunction(onClose) && onClose();
        this.setState({
            open:
                this.props.open == undefined ? false : this.state.open,
        });
        // isFunction(onBlur) && onBlur(value);
        this.picerPanel = document.querySelector('.u-time-picker-panel'); // 点击清除按钮的时候
        PubSub.unsubscribe('clearOpenPanel');
    };

    onChange = v => {
        let { onChange, format = 'HH:mm:ss', disabled } = this.props;
        isFunction(onChange) && onChange(!v ? v : v.format(format));
        this.v = v;
        if (disabled !== true && !v) {
            this.setState({ hasCloseBtn: false });
        }
    };

    // fixed onblur event -- bbqin
    // 用于tab 操作
    onBlur = e => {
        let { onBlur } = this.props;
        // tab操作  并且  open状态为flase
        if (this.keyboarded && !this.state.open) {
            isFunction(onBlur) && onBlur(this.state.value);
            this.focused = false;
            this.keyboarded = false;
        }
    };

    // 记录组件单元的focused状态
    onFocus = e => {
        this.focused = true;
        this.props.onFocus && this.props.onFocus(e);
    }

    render() {
        let props = this.props || {};
        let required = !!props.showStar;
        let {
            format = 'HH:mm:ss',
            className = '',
            tableOpen = false,
            onEnter,
            fieldid,
            popupClassName,
            hotKeyWithArrow,
            disabled,
            ...others
        } = props;
        let finalFormat = getDatetimeFormat(format);
        let { value } = this.state;

        this.v = value;

        let { hasCloseBtn } = this.state;

        if (getSysFieldid(fieldid)) {
            popupClassName = popupClassName ? popupClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
        }

        moment.locale('en');

        return (
            <div
                className={`u-form-control-wrapper ${className} `}
                fieldid={fieldid || null}
                onClick={e => {
                    e.stopPropagation();

                }}
                onKeyDown={
                    e => {
                        let isTab = [
                            e.keyCode,
                            e.which,
                            e.charCode,
                        ].find(e => e === 9);
                        isTab && (this.keyboarded = true);
                    }
                }
                ref={dom => {
                    this.timeInputWrap = dom;
                }}
            >
                <div
                    style={{ display: 'inline-block' }}
                    className="timepicker-hotkey-wrapper u-form-control-wrapper"
                    onKeyDown={e => {
                        if ([e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === 'Enter') {
                            onEnter && onEnter({ e, itemType: config.hotKeyDatePicker });
                        }

                        if (isArrowKeyDown(e)) {
                            hotKeyWithArrow && hotKeyWithArrow({ e, itemType: config.hotKeyDatePicker });
                        }
                    }}
                >
                    {required ? (
                        <span className="time-picker-required-tag">*</span>
                    ) : (
                        ''
                    )}
                    <OriginTimepicker
                        {...others}
                        popupClassName={popupClassName + ' nc-time-picker-panel'}
                        // open={this.state.open}
                        value={value ? moment(value, format) : null}
                        format={finalFormat}
                        //locale={locale}
                        ref={timeInput => {
                            this.timeInput = timeInput; // 获取到组件对象 -- bbqin
                        }}
                        onChange={this.onChange}
                        onOpen={this.onOpen}
                        onClose={this.onClose}
                        onBlur={this.onBlur}
                        onFocus={this.onFocus}
                        focusOnOpen={true} //  table open error fixed -- bbqin
                        showClear={false}
                        disabled={disabled}
                    // placeholder={format}
                    />
                    {hasCloseBtn && (
                        <i
                            className={"nc-datepicker-del-i iconfont icon-qingkong" + (disabled ? ' icon-hidden' : '')}
                            onClick={() => {
                                this.clearValue();
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}
